<template>
  <div class="documenti-utili-container" v-if="documenti.length > 0">
    <div v-if="showTitle" class="title">
      {{ intl[$store.state.lang]["useful-documents"] }}
    </div>
    <div class="list-group lista-documenti-utili">
      <button v-for="(documento) in documenti" :key="documento.id" type="button" class="list-group-item list-group-item-action bottone-documento"> 
        <a  :href="joomlaDocumentiUtiliBasePath + documento.url" target="_blank">
          <div class="titolo-descrizione-container d-inline-block">
            <div class="titolo"><span  v-html="documento.title && documento.title.toUpperCase()"></span></div>
            <div class="descrizione"><span  v-html="documento.description"></span></div>
          </div>
          <div class="d-inline-block">
            <img src="../../images/medialibrary/pdf_scarica_qui.png">
          </div>
        </a>
      </button>
    </div>
  </div>
</template>

<script>
import intl from "./intl/intl";
import axios from "axios";

import { apiUrls } from "../../api/apiUrls";
export default {
  name: "documentiUtili",
  components: {
    
  },
  props: {
    setPaginaLoaderCallback: {
        type: Function,
        default: (value) => {console.log("DOCUMENTI UTILI LOADER: ",value)},
      },
    answerId: {
      type: Number,
      default: null,
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
    renderComponent: {
      type: Boolean,
      default: true,
    },
    onLoadDataStarted: {
      type: Function,
      default: () => {
        console.log("Caricamento dati iniziato");
      },
    },
    onLoadDataEnded: {
      type: Function,
      default: (response,faqs) => {
        console.log("Caricamento dati finito");
      },
    },
  },

  created() {
    if (this.answerId) {
      this.getAnswerDetail();
    }
  },

  data: function () {
   return {
      intl: intl,
      documenti: [],
      documentiUtiliLoader: false
    };
  },
  methods: {
    getAnswerDetail() {
      if (this.answerId) {
        this.documentiUtiliLoader = true;
        this.onLoadDataStarted()
        axios
          .get(apiUrls["answer_detail"] + this.answerId)
          .then((response) => {
            if (
              response.data &&
              response.data.answerResource &&
              response.data.answerResource.length > 0
            ) {
              response.data.answerResource.map((resource) => {
                  this.documenti.push(resource);
              });
            }
           
            this.onLoadDataEnded(response,this.documenti)
        
            this.documentiUtiliLoader = false;
          })
          .catch((error) => {
            this.onLoadDataEnded(error,this.documenti)
       
            this.documentiUtiliLoader = false;
          });
      }
    },

   
  },
  watch: {
   documentiUtiliLoader : {
                handler : function(newValue, oldValue) {
                    if(oldValue !== newValue){
                        this.setPaginaLoaderCallback({documentiUtiliLoader: newValue})
                    }                
                },
                immediate: true, 
        },
  },
  computed: {
    joomlaDocumentiUtiliBasePath(){
      if(this.$store?.state?.libraryWiperConfig?.joomlaDocumentiUtiliBasePath){
        return this.$store?.state?.libraryWiperConfig?.joomlaDocumentiUtiliBasePath
      }else if(process.env.VUE_APP_JOOMLA_DOCUMENTI_UTILI_BASE_PATH){
        return process.env.VUE_APP_JOOMLA_DOCUMENTI_UTILI_BASE_PATH  
      }
      return ""
    }
  },
};
</script>
